import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabs-shell',
  templateUrl: './tabs-shell.component.html',
  styleUrls: ['./tabs-shell.component.scss'],
})
export class TabsShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
